// Lib
import React from 'react';
import PropTypes from 'prop-types';

// Components
import LiveCursorNameTag from './LiveCursorNameTag';
import Icon from '../../../../components/icons/Icon';

// Styles
import './LiveCursorTypePen.scss';

const LiveCursorTypePen = ({ user }) => (
    <div className="cursor LiveCursorTypePen">
        <Icon name="cursor-remote-pen" />
        <LiveCursorNameTag user={user} />
    </div>
);

LiveCursorTypePen.propTypes = {
    user: PropTypes.object,
};

export default LiveCursorTypePen;
